import { render, staticRenderFns } from "./manage_category.vue?vue&type=template&id=7fdfef7a&scoped=true"
import script from "./manage_category.vue?vue&type=script&lang=js"
export * from "./manage_category.vue?vue&type=script&lang=js"
import style0 from "./manage_category.vue?vue&type=style&index=0&id=7fdfef7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdfef7a",
  null
  
)

export default component.exports